import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import Angle from "../../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../../src/types/Interface";

import { ANGLE_COLORS } from "../../types/Config";
import { drawAngle, drawGuideAngles } from "./helpers/drawHelpers";
import { generateAnglePoints } from "../../../../../../src/utils/generator/generateAnglePoints";
import calcAngle from "../../../../../../src/utils/math/calcAngle";


export default class AngleManager {
  private angles = ANGLE_COLORS.map((color, colorI) => new Angle(`a${colorI + 1}`, { color, textColor: color }, 44));
  private isSuppMode: boolean = false;
  private currAngles: number[] = [];
  constructor() {
    eventBus.on(EnumEventBus.supplementaryMode, (v: boolean) => this.isSuppMode = v);
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }

  private emitAngles = (degrees: number[]) => eventBus.emit(EnumEventBus.setCalcLines, degrees);
  getAngles = () => this.angles;
  drawGuideAngle = (pArr: Coord[], degrees: number[]) => drawGuideAngles(this.angles[0], this.angles[3], degrees, pArr, false);
  setAllVisible = (v: boolean) => this.angles.forEach(angle => angle.setVisible(v));


  draw(pointArr: Coord[], clockwise: boolean) {
    const points = generateAnglePoints(pointArr);
    const angle1 = calcAngle(points[0].prev, points[0].curr, points[0].next)
    const angle2 = calcAngle(points[1].prev, points[1].curr, points[1].next)


    const degrees = [angle1, angle2, 180 - angle1, 180 - angle2];

    points.forEach((p, pI) => drawAngle(this.angles[pI], p, degrees[pI], clockwise))

    this.isSuppMode && this.drawGuideAngle(pointArr, [degrees[0], degrees[3]]);
    this.emitAngles(Array(4).fill(null).map((_, i) => degrees[i]));
  }
}